import React from 'react';
import { KeyRound } from 'lucide-react';
import CustomerLayout from '../../components/CustomerLayout';
import { CustomerPageHeading } from '../../components/customer/CustomerPageHeading';
import { PaymentPinSetup } from '../../components/customer/PaymentPinSetup';
import '../../styles/customer-payments.css';

export default function CustomerPinSetupPage() {
  return <CustomerLayout><section className="payment-page-narrow" data-testid="customer-pin-setup-page"><CustomerPageHeading title="Set up or reset your PIN" icon={KeyRound} testId="customer-pin-setup-heading" /><PaymentPinSetup /></section></CustomerLayout>;
}